/**
 * PROMENADE - Main Script (Fixed Version)
 */

/* =========================================
   1. スクロールアニメーション
   ========================================= */
const initScrollAnimations = () => {
  const targets = document.querySelectorAll('.js-fade-up');
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-active');
        obs.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
  targets.forEach(target => { observer.observe(target); });
};

/* =========================================
   2. ハンバーガーメニュー
   ========================================= */
const initMenu = () => {
  const hamburger = document.querySelector('.js-hamburger');
  const nav = document.querySelector('.js-nav');
  if (!hamburger || !nav) return;

  hamburger.addEventListener('click', (e) => {
    e.preventDefault();
    nav.classList.toggle('is-open');
    hamburger.classList.toggle('is-active');
  });
  document.querySelectorAll('.header__item a').forEach(link => {
    link.addEventListener('click', () => {
      nav.classList.remove('is-open');
      hamburger.classList.remove('is-active');
    });
  });
};

/* =========================================
   3. カテゴリフィルタ
   ========================================= */
const initCategoryFilter = () => {
  const filterButtons = document.querySelectorAll('.js-filter-buttons a');
  const filterItems = document.querySelectorAll('.js-filter-item');
  if (filterButtons.length === 0) return;

  filterButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      filterButtons.forEach((item) => item.classList.remove('is-active'));
      btn.classList.add('is-active');

      const targetCategory = btn.getAttribute('data-filter');
      filterItems.forEach((item) => {
        item.classList.remove('fade-in-anim');
        const itemCat = item.getAttribute('data-item');
        if (targetCategory === 'all' || targetCategory === itemCat) {
          item.classList.remove('is-hidden');
          item.style.display = "";
          setTimeout(() => item.classList.add('fade-in-anim'), 10);
        } else {
          item.classList.add('is-hidden');
          item.style.display = "none";
        }
      });
    });
  });
};

/* =========================================
   4. 商品画像ギャラリー
   ========================================= */
const initProductGallery = () => {
  const mainImage = document.getElementById('js-main-image');
  const thumbBtns = document.querySelectorAll('.thumb-btn');

  if (!mainImage || thumbBtns.length === 0) return;

  thumbBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const newSrc = btn.getAttribute('data-src');
      if (!newSrc) return;

      mainImage.style.transition = 'opacity 0.2s ease';
      mainImage.style.opacity = '0.5';

      setTimeout(() => {
        mainImage.src = newSrc;
        mainImage.style.opacity = '1';
      }, 200);

      thumbBtns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });
};

/* =========================================
   5. 数量変更 & 画像SP/PC切り替え (イベント委譲版)
   ========================================= */
const initQuantityDelegation = () => {
  if (window.promenadeQtyInitialized) return;
  window.promenadeQtyInitialized = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return; // 関係ない場所のクリックなら無視
    e.preventDefault(); // ボタンのデフォルト動作を無効化
    // 入力欄を探す
    const selector = btn.closest('.qty-selector');
    const input = selector ? selector.querySelector('input[type="number"]') : null;
    if (!input) return;

    let val = parseInt(input.value) || 0;
    
    // マイナスボタン
    if (btn.classList.contains('minus')) {
      // カート内(updates[])なら0までOK、商品ページなら1まで
      const min = input.name === 'updates[]' ? 0 : 1;
      if (val > min) {
        input.value = val - 1;
        input.dispatchEvent(new Event('change', { bubbles: true })); // 変更を通知
      }
    }
    // プラスボタン
    else if (btn.classList.contains('plus')) {
      input.value = val + 1;
      input.dispatchEvent(new Event('change', { bubbles: true })); // 変更を通知
    }
  });

  // カート画面専用：自動更新ロジック (イベント委譲)
  const cartForm = document.querySelector('.cart-form');
  if (cartForm) {
    cartForm.addEventListener('change', (e) => {
      // 数量入力欄が変更された場合のみ
      if (e.target.matches('input[name="updates[]"]')) {
        // 連打対策（0.3秒待ってから送信）
        clearTimeout(window.cartSubmitTimer);
        window.cartSubmitTimer = setTimeout(() => {
          cartForm.submit();
        }, 300);
      }
    });
  }
};

const initImageSwitch = () => {
  const targets = document.querySelectorAll('.js-switch-img');
  if (targets.length === 0) return;
  const switchSrc = () => {
    const isSp = window.innerWidth <= 768;
    targets.forEach(img => {
      const spSrc = img.getAttribute('data-sp');
      const pcSrc = img.getAttribute('data-pc');
      if (isSp && spSrc && img.src !== spSrc) img.src = spSrc;
      else if (!isSp && pcSrc && img.src !== pcSrc) img.src = pcSrc;
    });
  };
  switchSrc();
  window.addEventListener('resize', switchSrc);
};

/* =========================================
   実行処理
   ========================================= */
document.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initMenu();
  initCategoryFilter();
  initProductGallery();
  initQuantityDelegation(); // 新しい関数名に変更
  initImageSwitch();
});